export enum PartnerCompaniesQueryKeysEnum {
  PARTNER_COMPANIES_STATE = 'partnerCompanyListState',
}
